export default "__VITE_ASSET__Y8TwW_$Z__"